// extracted by mini-css-extract-plugin
export var blockDesc = "free-module--block-desc--8b5fb";
export var free = "free-module--free--23b17";
export var row = "free-module--row--1648b";
export var videoDesc = "free-module--video-desc--bfc01";